module.exports = __webpack_public_path__ + "assets/img/485e72c2f4ac4ec81b0b70ad50a49ac3.svg";